import React from "react";

import {
  Box,
  Button,
  Stack,
  Typography,
} from "@mui/material";

import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import InsightsRoundedIcon from "@mui/icons-material/InsightsRounded";

interface AnalyticsHeaderProps {
  loading?: boolean;
  onRefresh: () => void;
  onExport: () => void;
}

const AnalyticsHeader: React.FC<
  AnalyticsHeaderProps
> = ({
  loading = false,
  onRefresh,
  onExport,
}) => {
  return (
    <Box
      mb={3}
      display="flex"
      justifyContent="space-between"
      alignItems={{
        xs: "flex-start",
        md: "center",
      }}
      flexDirection={{
        xs: "column",
        md: "row",
      }}
      gap={2}
    >
      <Box>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          mb={0.5}
        >
          <InsightsRoundedIcon
            color="primary"
          />

          <Typography
            variant="h4"
            fontWeight={800}
            sx={{ fontSize: { xs: "1.4rem", md: "1.7rem" }, letterSpacing: "-.6px" }}
          >
            Analytics Dashboard
          </Typography>
        </Stack>

        <Typography
          variant="body2"
          color="text.secondary"
        >
          Monitor inventory, maintenance,
          suppliers, purchases and spare
          parts performance across all hubs.
        </Typography>
      </Box>

      <Stack
        direction="row"
        spacing={2}
      >
        <Button
          variant="outlined"
          startIcon={<RefreshRoundedIcon />}
          onClick={onRefresh}
          disabled={loading}
        >
          Refresh
        </Button>

        <Button
          variant="contained"
          startIcon={<DownloadRoundedIcon />}
          onClick={onExport}
          disabled={loading}
        >
          Export Report
        </Button>
      </Stack>
    </Box>
  );
};

export default AnalyticsHeader;
